jQuery(document).ready(function($){


  // Daterange picker initializer
  if (window.is_mobile_device) {
    $('#inline-booking-bot-form input[name=checkinout_date_display], #sidebar-booking-bot-form input[name=checkinout_date_display], #redeem-offer-booking-bot-form  input[name=checkinout_date_display]').daterangepicker({
      locale: {
        format: 'MM/DD'
      },
      "alwaysShowCalendars": true,
      "maxSpan": {
        "days": 7
      },
      minDate: moment().format("MM/DD"),
      autoApply: true,
      singleCalendar: true
    });
  } else {
    $('#inline-booking-bot-form input[name=checkinout_date_display], #sidebar-booking-bot-form input[name=checkinout_date_display], #redeem-offer-booking-bot-form  input[name=checkinout_date_display]').daterangepicker({
      locale: {
        format: 'MM/DD'
      },
      "alwaysShowCalendars": true,
      "maxSpan": {
        "days": 7
      },
      minDate: moment().format("MM/DD"),
      autoApply: true
    });
  }
  
  $('#inline-booking-bot-form input[name=checkinout_date_display]').on('apply.daterangepicker', function(ev, picker) {
    $('#inline-booking-bot-form input[name=checkin_date]').val(picker.startDate.format('MM/DD/YYYY'));
    $('#inline-booking-bot-form input[name=num_nights]').val(picker.endDate.diff(picker.startDate, 'days'));
  });

  $('#sidebar-booking-bot-form input[name=checkinout_date_display]').on('apply.daterangepicker', function(ev, picker) {
    $('#sidebar-booking-bot-form input[name=checkin_date]').val(picker.startDate.format('MM/DD/YYYY'));
    $('#sidebar-booking-bot-form input[name=num_nights]').val(picker.endDate.diff(picker.startDate, 'days'));
  });

  $('#redeem-offer-booking-bot-form input[name=checkinout_date_display]').on('apply.daterangepicker', function(ev, picker) {
    $('#redeem-offer-booking-bot-form input[name=checkin_date]').val(picker.startDate.format('MM/DD/YYYY'));
    $('#redeem-offer-booking-bot-form input[name=num_nights]').val(picker.endDate.diff(picker.startDate, 'days'));
  });
  
  $('#inline-booking-bot-more-details').on('show.bs.collapse', function () {
    $('.js-inline-booking-bot-wrapper').addClass('extra-fields-shown');

    if ($(window).width() < 1260) {
      $('.inline-booking-bot-wrapper .book-now-button').addClass('move-button-down');
      $('.more-details-btn').removeClass('d-none');
    }
  });

  $('#inline-booking-bot-more-details').on('hidden.bs.collapse', function () {
    $('.js-inline-booking-bot-wrapper').removeClass('extra-fields-shown');

    if ($(window).width() < 1260) {
      $('.inline-booking-bot-wrapper .book-now-button').removeClass('move-button-down');
      $('.more-details-btn').addClass('d-none');
    }
  });


  $('#my-winstar-menu .js-book-now-link > a').on('shown.bs.popover', function() {
    // Required to load after the popover is displayed
    if (casino.logged_in == "true" && casino.patron !== undefined) {
      $('input.passport-input').val(casino.patron.patronNumber);
      $('input.zip-input').val(casino.patron.zip);
    }
  });

  $('.header-mobile__menu-btn__book > a').on('show.bs.popover', function() {
    window.resetMenu(true);
  });

  $('.header-mobile__menu-btn__book > a').on('shown.bs.popover', function() {
    $('body').addClass('mobile-menu-active');
    $('.js-header-mobile__book').addClass('active');
    $('.header-mobile__my-riverwind-popover').popover('hide');

    var targetElement = $('.popover-mobile-book').length > 0 ? $('.popover-mobile-book')[0] : null;
    if (targetElement !== null) {
      bodyScrollLock.disableBodyScroll(targetElement);
    }
  });

  $('.header-mobile__menu-btn__book > a').on('hide.bs.popover', function() {
    $('body').removeClass('mobile-menu-active');
    window.resetMenu(false, "booking");
  });

  $('.header-mobile__menu-btn__book > a').on('hidden.bs.popover', function() {
    $(".js-header-mobile__book").removeClass("active");

    bodyScrollLock.clearAllBodyScrollLocks();
  });
  

  if (casino.logged_in == "true" && casino.patron !== undefined) {
    $('input.passport-input').val(casino.patron.patronNumber);
    $('input.zip-input').val(casino.patron.zip);
  }

  if (casino.logged_in == "true") {
    if ( $('#sidebar-booking-bot-form').length ) {
      $('.user-notice h5').html('Hello <span class="name">' + casino.firstName + '</span>,').removeClass('d-none');
    }
  }

  $(document).on('submit', '#inline-booking-bot-form, #popover-booking-bot-form, #sidebar-booking-bot-form, #redeem-offer-booking-bot-form', function(e){

    var form_id = '#' + $(this).attr('id');

    var passport = $(form_id + ' input[name=passport_card_number]').val();
    var zipcode = $(form_id + ' input[name=zip]').val();
    var pin = $(form_id + ' input[name=pin]').val();
    var where = $(form_id + ' [name=location_code]').val();
    if(!where) where = 'RW';

    if(passport && zipcode && pin)
    {
      if(!$(form_id + ' input[name=zip]').valid() || !$(form_id + ' input[name=pin]').valid() || !$(form_id + ' input[name=passport_card_number]').valid())
      {
        e.preventDefault();
        return false;
      }

      $('<input>').attr('type', 'hidden').attr('name', 'patron').attr('value', passport).appendTo(this);
      $('<input>').attr('type', 'hidden').attr('name', 'offer').attr('value', 0).appendTo(this);
      $('<input>').attr('type', 'hidden').attr('name', 'resDate').attr('value', 0).appendTo(this);
      $('<input>').attr('type', 'hidden').attr('name', 'nights').attr('value', 0).appendTo(this);
      $('<input>').attr('type', 'hidden').attr('name', 'property').attr('value', where).appendTo(this);

      return true;
    }
    else
    {
      e.preventDefault();
    
      window.location.href = 'https://book.rguest.com/onecart/wbe/calendar/686/Riverwind-Casino/RWBOOK';
    }
    return false;
    
  });
    

  // Display only one popover at a time
  $('#my-riverwind-menu li a.nav-link').on('click', function (e) {
    $('#my-riverwind-menu li a.nav-link').not(this).popover('hide');
  });

});
